// Preserve the entire internal route across authentication, including an intake step/tab.
// Never interpret an external or protocol-relative destination as an application route.
export function loginReturnTo(state: unknown): string {
  if (!state || typeof state !== "object" || !("from" in state)) return "/dashboard"
  const from = state.from
  if (!from || typeof from !== "object" || !("pathname" in from)) return "/dashboard"
  const pathname = from.pathname
  if (typeof pathname !== "string" || !pathname.startsWith("/") || pathname.startsWith("//") || pathname.includes("\\") || pathname === "/login") {
    return "/dashboard"
  }
  const search = "search" in from && typeof from.search === "string" && from.search.startsWith("?") ? from.search : ""
  const hash = "hash" in from && typeof from.hash === "string" && from.hash.startsWith("#") ? from.hash : ""
  return `${pathname}${search}${hash}`
}
